<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :default-active="defaultActive"
      class="el-menu-vertical"
      background-color="#F5F5F5"
      :collapse="collapse"
    >
      <template v-for="(item,index) in dataList" :item="item">
        <div class="menu-wrapper" :key="index">
          <a v-if="!item.kindOne">
            <router-link :to="item.path">
              <el-menu-item :index="item.key">
                <i class="menu-icon fa" :class="item.icon" aria-hidden="true"></i>
                <span class="navTitle" slot="title">{{ item.title }}</span>
              </el-menu-item>
            </router-link>
          </a>
          <el-submenu :collapse="collapse" :index="item.key" v-else>
            <template slot="title">
              <i class="menu-icon fa" :class="item.icon" aria-hidden="true"></i>
              <span class="navTitle">{{ item.title }}</span>
            </template>
            <div v-for="(itemValue, indexValue) in item.kindOne" :key="indexValue">
              <router-link :to="itemValue.path">
                <el-menu-item :index="itemValue.key">
                  <span class="navTitleTwo">{{ itemValue.title }}</span>
                </el-menu-item>
              </router-link>
            </div>
          </el-submenu>
        </div>
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script>
export default {
  props: {
    collapse: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      activeRoutePath: this.$route.path,
      dataList: [],
      // 个人用户
      dataList1:[{
        'key':'overview',
        'title':this.$root.lang.navMenu.overview,
        'icon':'fa-bar-chart',
        'path':"/control/dashboard"
      },{
        'key':'devices',
        'title':this.$root.lang.navMenu.deviceManage,
        'icon':'fa-tablet',
        'kindOne':[
            {
            'key':'device',
            'title':this.$root.lang.navMenu.device,
            'path':'/control/devices/device'
            }
        ]
      },
      {
        'key':'apps',
        'icon':'fa-th-large',
        'title':this.$root.lang.navMenu.appManage,
        'kindOne':[
            {
            'key':'private',
            'title':this.$root.lang.navMenu.privateApp,
            'path':'/control/apps/private'
            },
            {
            'key':'public',
            'title':this.$root.lang.navMenu.publicApp,
            'path':'/control/apps/public'
            },
            // {
            // 'key':'application',
            // 'title':this.$root.lang.navMenu.application,
            // 'path':'/control/apps/application'
            // },
        ]
      },
      {
        'key':'visual',
        'icon':'fa-tv',
        'title':this.$root.lang.navMenu.visualManage,
        'kindOne':[
            {
            'key':'type',
            'title':this.$root.lang.navMenu.visualType,
            'path':'/control/visual/type'
            },
            {
            'key':'page',
            'title':this.$root.lang.navMenu.visualPage,
            'path':'/control/visual/page'
            },
        ]
      },
      {
        'key':'ssllog',
        'icon':'fa-tv',
        'title':"远程连接SSH",
        'kindOne':[
            // {
            // 'key':'type',
            // 'title':this.$root.lang.navMenu.visualType,
            // 'path':'/control/ssllog/type'
            // },
            {
            'key':'page',
            'title':"SSH",
            'path':'/control/ssllog/page'
            },
        ]
      },
      {
        'key':'block',
        'icon':'fa-chain',
        'title':this.$root.lang.navMenu.blockManage,
        'kindOne':[
            {
            'key':'chain',
            'title':this.$root.lang.navMenu.blockPage,
            'path':'/control/block/chain'
            },
        ]
      },
      {
        'key':'user',
        'icon':'fa-user',
        'title':this.$root.lang.navMenu.user,
        'path':'/control/user'
      },
      ],
      // 企业用户（审核成功），对内
      dataList2:[{
        'key':'overview',
        'title':this.$root.lang.navMenu.overview,
        'icon':'fa-bar-chart',
        'path':"/control/dashboard"
      },{
        'key':'devices',
        'title':this.$root.lang.navMenu.deviceManage,
        'icon':'fa-tablet',
        'kindOne':[
            {
            'key':'device',
            'title':this.$root.lang.navMenu.device,
            'path':'/control/devices/device'
            },
            {
            'key':'group',
            'title':this.$root.lang.navMenu.group,
            'path':'/control/devices/group'
            },
        ]
      },
      {
        'key':'apps',
        'icon':'fa-th-large',
        'title':this.$root.lang.navMenu.appManage,
        'kindOne':[
            {
            'key':'private',
            'title':this.$root.lang.navMenu.privateApp,
            'path':'/control/apps/private'
            },
            {
            'key':'public',
            'title':this.$root.lang.navMenu.publicApp,
            'path':'/control/apps/public'
            },
        ]
      },
      // {
      //   'key':'visual',
      //   'icon':'fa-tv',
      //   'title':this.$root.lang.navMenu.visualManage,
      //   'kindOne':[
      //       {
      //       'key':'type',
      //       'title':this.$root.lang.navMenu.visualType,
      //       'path':'/control/visual/type'
      //       },
      //       {
      //       'key':'page',
      //       'title':this.$root.lang.navMenu.visualPage,
      //       'path':'/control/visual/page'
      //       },
      //   ]
      // },
      {
        'key':'user',
        'icon':'fa-user',
        'title':this.$root.lang.navMenu.user,
        'path':'/control/user'
      },
      ],
      // 企业用户（审核中或审核失败）
      dataList3:[{
        'key':'user',
        'icon':'fa-user',
        'title':this.$root.lang.navMenu.user,
        'path':'/control/user'
      },
      ],
      // 企业用户（审核成功），对外，有生成秘钥功能
      dataList4:[{
        'key':'overview',
        'title':this.$root.lang.navMenu.overview,
        'icon':'fa-bar-chart',
        'path':"/control/dashboard"
      },{
        'key':'devices',
        'title':this.$root.lang.navMenu.deviceManage,
        'icon':'fa-tablet',
        'kindOne':[
            {
            'key':'device',
            'title':this.$root.lang.navMenu.device,
            'path':'/control/devices/device'
            },
            {
            'key':'group',
            'title':this.$root.lang.navMenu.group,
            'path':'/control/devices/group'
            },
        ]
      },
      {
        'key':'apps',
        'icon':'fa-th-large',
        'title':this.$root.lang.navMenu.appManage,
        'kindOne':[
            {
            'key':'private',
            'title':this.$root.lang.navMenu.privateApp,
            'path':'/control/apps/private'
            }
        ]
      },{
        'key':'user',
        'icon':'fa-user',
        'title':this.$root.lang.navMenu.user,
        'path':'/control/user'
      },
      ],
    }
  },
  watch: {
    $route(to, from) {
      // this.activeRoutePath = this.$route.path;
    }
  },
  computed: {
    defaultActive: function () {
      return this.search(this.dataList);
    }
  },
  created() {
    this.init()
  },
  methods: {
    search(list) {
      for (const item of list) {
        if (item.path === this.activeRoutePath) {
          return item.key;
        } else {
          if(this.activeRoutePath.indexOf(item.path) != -1) {
            return item.key;
          }
        }
        if (item.kindOne) {
          const key = this.search(item.kindOne);
          if (key !== undefined) {
            return key;
          }
        }
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    getRoute(str) {
      if(this.$route.path.indexOf(str) > 0) return true;
      else return false;
    },
    init() {
      // 个人用户
      if(this.Cookies.get('T') == '1') {
        this.dataList = this.dataList1
      } else {
        // 企业用户
        // 未审核或审核失败
        if(this.Cookies.get('S') != '1') {
          this.dataList = this.dataList3
        } else {
          if(this.Cookies.get('O') == '1') {
            this.dataList = this.dataList4
          } else {
            this.dataList = this.dataList2
          }
        }
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
>>> .el-menu-item {
  padding-left: 0;
  .menu-icon {
    margin-right: 10px;
    margin-left: -10px;
    color: #555555;
  }
  .navTitle {
    color: #555555;
    display: inline-block;
    min-width: 88px;
    text-align: left;
    font-size: 14px;
    font-weight: 700;
  }
  .navTitleTwo {
    display: inline-block;
    min-width: 88px;
    // padding-left: 30px;
    text-align: left;
    color: #555555;
  }
  &:hover, &:focus, &.is-active {
    background-color: #f8fafc !important;

    .navTitleTwo, .navTitle, .menu-icon {
      color: #409eff;
    }
  }
}
>>> .el-submenu__title {
  .menu-icon {
    margin-right: 10px;
    margin-left: -10px;
    color: #555555;
  }
  .navTitle {
    color: #555555;
    display: inline-block;
    min-width: 88px;
    text-align: left;
    font-size: 14px;
    font-weight: 700;
  }
  &:hover, &:focus {
    background-color: #F5F5F5 !important;

    .navTitle, .menu-icon {
      color: #555555;
    }
  }
}
.menu-wrapper {

  a {
    display: inline-block;
    width: 100%;
    overflow: hidden;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/controlCenter/layout/components/Sidebar/index.vue